/*eslint-disable*/
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Grid } from "@material-ui/core";

function CircularLoading({ label }) {

  label = label || "Loading...";

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <CircularProgress />

      <p style={{padding:10,marginTop:"10px"}}>{label}</p>

    </Grid>
  );
}

export default CircularLoading;
